// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Expanding Image
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

//Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

function infoItems(showMarkers, infoSection) {

  // Animate individual items
  var infoItems = infoSection.querySelectorAll(".info-item");

  infoItems.forEach((infoItem, i) => {

    const infoItemEntry = gsap.timeline({
      paused: "true",
      scrollTrigger: {
        trigger: infoItem,
        start: "top center",
        toggleActions: "play pause resume resume",
        id: "info-item",
        pinReparent: true,
        markers: showMarkers,
      },
    });


    gsap.set(infoItem, {opacity:0, y: 76});
    infoItemEntry.to(infoItem, {opacity: 1, y:0, duration: 1}, 0)

    var infoItemImg = infoItem.querySelector("img");

    gsap.set(infoItemImg, {scale: 1.2});
    infoItemEntry.to(infoItemImg, {scale: 1, duration: 1.2, delay: .25}, 0)

  });

  // Animate card links
  var infoCardBtn = infoSection.querySelector(".card-btn");

  if(infoCardBtn){

    const infoCardEntry = gsap.timeline({
      paused: "true",
      scrollTrigger: {
        trigger: infoItems,
        start: "top center",
        toggleActions: "play pause resume resume",
        id: "info-item",
        markers: showMarkers,
      },
    });

    gsap.set(infoCardBtn, { scale: 0.6, opacity: 0, transformOrigin: "0% 80%" });
    infoCardEntry.to(infoCardBtn,{scale: 1, opacity: 1, duration: 1.2, delay: .25}, 0);
  }

}

export { infoItems };
